"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var AccordionItem_1 = require("../AccordionItem");
var helpers_1 = require("../../helpers");
function TBAccordion(_a) {
    var blok = _a.blok;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: " mx-auto max-w-5xl px-4 xl:px-0  ".concat((0, helpers_1.topiaBlockClassnames)(blok)) }, (0, react_1.storyblokEditable)(blok), { children: [(0, jsx_runtime_1.jsx)("div", { className: "topia-sb-rich-text", dangerouslySetInnerHTML: {
                    __html: (0, helpers_1.topiaRichText)(blok.title),
                } }), (0, jsx_runtime_1.jsx)("section", { className: "flex w-full flex-col ", children: blok.accordion_block.map(function (acc) { return ((0, jsx_runtime_1.jsx)(AccordionItem_1.AccordionItem, { detail: acc.detail, header: acc.header }, acc.uuid)); }) })] })));
}
exports.TBAccordion = TBAccordion;
